<template>
  <v-form :ref="type + '-estrangeiro-form'" v-model="formValid">
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          class="jns-input"
          label="Razão Social"
          placeholder=" "
          :rules="[rules.required]"
          v-model="person.name"
          append-icon="search"
          @click:append="$emit('click:append')"
          @keyup.enter="$emit('keyup.enter')"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          class="jns-input"
          v-if="person.stepType == 3 && person.notFound && showCademp"
          label="Cademp"
          @keypress="isNumberOrDash($event)"
          placeholder=" "
        ></v-text-field>
      </v-flex>

      <v-flex xs2>
        <v-text-field
          class="jns-input"
          :rules="[rules.required]"
          v-model="person.enderecos[0].cep"
          v-mask="'#####-###'"
          label="CEP"
          placeholder=" "
        ></v-text-field>
      </v-flex>
      <v-flex xs5>
        <v-text-field
          class="jns-input"
          :rules="[rules.required]"
          v-model="person.enderecos[0].rua"
          label="Endereço"
          placeholder=" "
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field
          class="jns-input"
          :rules="[rules.required]"
          v-model="person.enderecos[0].numero"
          @keypress="isNumberOrDash($event)"
          label="Número"
          maxlength="8"
          placeholder=" "
        ></v-text-field>
      </v-flex>
      <v-flex xs3>
        <v-text-field
          class="jns-input"
          v-model="person.enderecos[0].complemento"
          label="Complemento"
          placeholder=" "
        ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-text-field
          class="jns-input"
          :rules="[rules.required]"
          v-model="person.enderecos[0].bairro"
          label="Bairro"
          placeholder=" "
        ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-text-field
          class="jns-input"
          :rules="[rules.required]"
          v-model="person.enderecos[0].cidade"
          label="Cidade"
          placeholder=" "
        ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-text-field
          class="jns-input"
          :rules="[rules.required]"
          v-model="person.enderecos[0].uf"
          label="UF"
          @keypress="isLetter($event)"
          maxlength="2"
          placeholder=" "
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<style lang='scss' scoped>
</style>

<script lang="js">
import { isNumberOrDash, isLetter } from "@/libs/utils";

export default {
  name: "PropostaForm",
  data: () => ({
    isNumberOrDash,
    isLetter,
    formValid: true,
    rules: {
      required: (v) => !!v || "Este campo é obrigatório!",
    }
  }),
  props: ["person", "showCademp", "type"],
  watch: {
    person: {
      handler(newValue) {
        this.$emit("updatePerson", this.person);
      },
      deep: true,
    },
    formValid: {
      handler(newValue) {
        this.$emit("formValid", this.formValid);
      },
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/PropostaForm.vue